if (!customElements.get('wholesale-button-patch')) {
  class WholesaleButtonPatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('wholesale-button'));
      this.zeroQuantityButtons = this.buttons.filter(
        (button) => button.getAttribute('data-min-quantity') == '0',
      );

      if (!this.zeroQuantityButtons.length) return;

      this.zeroQuantityButtons.forEach((button) => {
        const buttonsWithSameVariant = this.buttons.filter(
          (wholesaleButton) =>
            wholesaleButton != button &&
            wholesaleButton.getAttribute('data-variant-id') ==
              button.getAttribute('data-variant-id'),
        );

        const currentPrice = button.getAttribute('data-price');

        buttonsWithSameVariant.forEach((nextButton) => {
          const percentage = Number(
            nextButton.getAttribute('data-percent-discount'),
          );
          if (!percentage) return;

          let finalPrice = currentPrice - (currentPrice * percentage) / 100;

          const decimal = finalPrice % 1;

          // Round down if decimal is .5 or less, otherwise round up
          finalPrice =
            decimal <= 0.5 ? Math.floor(finalPrice) : Math.ceil(finalPrice);

          nextButton.setAttribute('data-price', finalPrice);
          nextButton.setAttribute('data-price-per-item', finalPrice);
        });
      });
    }
  }

  customElements.define('wholesale-button-patch', WholesaleButtonPatch);
}
